import { createAccessControl } from "better-auth/plugins/access";
import { defaultStatements } from "better-auth/plugins/organization/access";

const statement = {
    ...defaultStatements,
    member: ["create", "update", "delete", "read"],
    staff: ["create", "update", "delete", "read"],
    trainer: ["read"],
    plan: ["create", "update", "read"],
    expense: ["create", "update", "delete", "read"],
    attendance: ["create", "update", "delete", "read"],
    staffAttendance: ["create", "update", "read"],
    notes: ["create", "update", "delete", "read"],
    invitation: ["create", "read", "update", "delete"],
    payment: ["create", "update", "read"],
    leave: ["create", "update", "delete", "read"],
    accessControl: ["create", "update", "read"],
    offer: ["create", "update", "delete", "read"],
    setting: ["update", "read"],
    product: ["create", "update", "delete", "read"],
    sale: ["create", "update", "delete", "read"],
    lead: ["create", "update", "delete", "read"],
} as const;

export const ac = createAccessControl(statement);

export const owner = ac.newRole({
    organization: ["update", "delete"],
    member: ["create", "update", "delete", "read"],
    staff: ["create", "update", "delete", "read"],
    trainer: ["read"],
    plan: ["create", "update", "read"],
    expense: ["create", "update", "delete", "read"],
    attendance: ["create", "update", "delete", "read"],
    staffAttendance: ["read"],
    invitation: ["create", "read", "update", "delete"],
    notes: ["create", "update", "delete", "read"],
    payment: ["create", "update", "read"],
    leave: ["update", "delete", "read"],
    accessControl: ["create", "update", "read"],
    offer: ["create", "update", "delete", "read"],
    setting: ["update", "read"],
    product: ["create", "update", "delete", "read"],
    sale: ["create", "update", "delete", "read"],
    lead: ["create", "update", "delete", "read"],
});

export const admin = ac.newRole({
    member: ["create", "update", "delete", "read"],
    staff: ["create", "update", "delete", "read"],
    trainer: ["read"],
    plan: ["create", "update", "read"],
    expense: ["create", "update", "delete", "read"],
    attendance: ["create", "update", "delete", "read"],
    staffAttendance: ["create", "update", "read"],
    invitation: ["create", "read", "update", "delete"],
    notes: ["create", "update", "delete", "read"],
    payment: ["create", "update", "read"],
    leave: ["create", "update", "read"],
    accessControl: ["read"],
    offer: ["create", "update", "delete", "read"],
    setting: ["update", "read"],
    product: ["create", "update", "delete", "read"],
    sale: ["create", "update", "delete", "read"],
    lead: ["create", "update", "delete", "read"],
});

export const trainer = ac.newRole({
    member: ["read"],
    staff: [],
    trainer: ["read"],
    plan: ["read"],
    expense: [],
    attendance: ["create", "update", "delete", "read"],
    staffAttendance: ["create", "update", "read"],
    notes: ["create", "update", "delete", "read"],
    invitation: [],
    payment: [],
    leave: ["create", "read"],
    accessControl: [],
    product: ["read"],
    sale: ["create", "read"],
    lead: ["create", "update", "read"],
});

export const member = ac.newRole({
    plan: [],
});

export type Resources = keyof typeof statement;
export type Actions = (typeof statement)[Resources][number];
export type Permissions = Partial<{
    [K in Resources]: (typeof statement)[K][number][];
}>;
